import React from "react";
import Helmet from "react-helmet";
import Header from "./header"
import Footer from "./footer"
import {Link} from "react-router-dom"
function Privacypolicy(){
  return (
    <div>
     <Header />
         <section className="page-title centred" style={{backgroundImage: 'url(https://images.unsplash.com/photo-1545486332-9e0999c535b2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NXx8YmxhY2t8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60)'}}>
<div className="auto-container">
<div className="content-box">
  <div className="title">
    <h1>Privacy Policy</h1>
  </div>
  <ul className="bread-crumb clearfix">
    <li>
        <Link to="/">Home</Link>
    </li>
    
  </ul>
</div>
</div>
</section>
   <section className="sidebar-page-container">
<div className="auto-container">
<div className="row clearfix">
  <div className="col-lg-12 col-md-12 col-sm-12 content-side">
    <div className="blog-details-content">
      <div className="news-block-one">
        <div className="inner-box">
          <div className="lower-content">
            
            <h2>Privacy Policy</h2>
            <div className="text">
              <p></p>Thank you for visiting Gems.com! We want you to know that your privacy is important to us.
Our customers are at the heart of everything we do, and we strive to ensure your experience
with Gems.com is one that you will want to repeat and share with your friends. Part of our
commitment to you is to respect and protect the privacy of the personal information you
provide to us. The information below is designed to inform you of what information we collect,
why we collect such information, and how we use the information we collect. This Privacy
Policy is incorporated into our Terms of Service.
In particular, the Notice describes the categories of personal data we may process, how
your personal data may be processed and how your privacy is safeguarded in the course of our
relationship with you. It is intended to comply with our obligations to provide you with
information about the Company's processing of your personal data.
We take your data protection rights and our legal obligations seriously. Your a will be treated in
a secure and confidential manner and only as detailed in this Notice
When you submit your personal information to us, you are giving us your consent to the
collection, use, and disclosure of your information as set forth in this Privacy Policy. We are
always available to discuss your questions or concerns regarding this Privacy Policy and our
privacy practices. If you would like to speak to a customer service representative.
Please contact us via telephone at <span style={{color:"black"}}> 09111213145</span> or email at <span style={{color:"black"}}> enku@gmail.com</span>
            </div>
            
          </div>
        </div>
      </div>
   
    </div>
  </div>
</div>
</div>
</section>

<Footer />

    </div>
)
}
export default Privacypolicy;